import {UIStoreGiftOverlayController} from '../../../shared/scripts/store/gift/UIStoreGiftOverlayController'
import {uiManager} from '../EntryHomepage'
import {Scene} from '../ui_html/UISceneTypes'
import {UIStoreGiftBaseSelectionController} from '../../../shared/scripts/store/gift/UIStoreGiftBaseSelectionController'
import {GiftingFlowAnalytics} from '../../../../shared/entity_datas/EntityDatas'
import {DiscordInstance} from '../discord/DiscordInstance'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {ColonistOneTimePurchaseType, BigId} from '@colonist/types'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {GiftPurchaseData} from '../../../../shared/store/GiftPurchaseData'

export class UIDStoreGiftOverlayController extends UIStoreGiftOverlayController {
    protected override init() {
        this.createHeaderSection()
        this.createBodySection()
    }

    // eslint-disable-next-line class-methods-use-this
    protected override async executeCheckout(giftTier: ColonistOneTimePurchaseType, giftPurchaseData: GiftPurchaseData) {
        const result = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSaveGiftMetadata(), undefined, giftPurchaseData)
        if(result == undefined) return

        const giftMetadataId = result.json as BigId
        StorageWrapper.setGiftMetadataId(giftMetadataId)

        UIStoreGiftBaseSelectionController.sendGiftFlowAnalytics(GiftingFlowAnalytics.SuccessfulCheckoutClick)
        DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseGift, giftTier)
    }

    // eslint-disable-next-line class-methods-use-this
    protected override goToHomepage() {
        uiManager.sceneController.loadScene(Scene.MainPage)
    }

    // eslint-disable-next-line class-methods-use-this
    override hide() {
        uiManager.sceneController.loadScene(Scene.DiscordStore)
    }

    // eslint-disable-next-line class-methods-use-this
    override show() {
        uiManager.sceneController.loadScene(Scene.DiscordGifting)
    }
}
